import { metricsTrack } from '../components/utilities/analytics/index.js';
import { isSameOrigin } from '../components/utilities/backend-helpers/index.js';
import '../components/atoms/buttons/enums.js';
import { isLink, getLinkURL } from '../components/utilities/dom-helpers/index.js';
import { MainCategoriesItem } from '../components/organisms/main-categories/main-categories-item.js';

/* eslint-disable sonarjs/cognitive-complexity */
function getFormAttributes(form, trackingEvent = '') {
    var _a, _b, _c, _d;
    const lang = (_a = document
        .querySelector('html')
        .getAttribute('lang')) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    let consentDataProcessingVal;
    let consentRetailReferralVal;
    let consentMarketingVal;
    const dataProcessingElementIdVar = `${(_b = window.formConsentsElements) === null || _b === void 0 ? void 0 : _b.dataProcessingElementId}_0`;
    const retailReferralElementIdVar = `${(_c = window.formConsentsElements) === null || _c === void 0 ? void 0 : _c.retailReferralElementId}_0`;
    const marketingElementIdVar = `${(_d = window.formConsentsElements) === null || _d === void 0 ? void 0 : _d.marketingElementId}_0`;
    if (trackingEvent === 'cevt_form_success') {
        consentDataProcessingVal = sessionStorage.getItem('consentDataProcessing');
        consentRetailReferralVal = sessionStorage.getItem('consentRetailReferral');
        consentMarketingVal = sessionStorage.getItem('consentMarketing');
    }
    else {
        const consentDataProcessing = document.getElementById(dataProcessingElementIdVar);
        const consentRetailReferral = document.getElementById(retailReferralElementIdVar);
        const consentMarketing = document.getElementById(marketingElementIdVar);
        if (consentDataProcessing !== null) {
            consentDataProcessingVal = (consentDataProcessing === null || consentDataProcessing === void 0 ? void 0 : consentDataProcessing.checked) ? 'yes' : 'no';
        }
        if (consentMarketing !== null) {
            consentMarketingVal = (consentMarketing === null || consentMarketing === void 0 ? void 0 : consentMarketing.checked) ? 'yes' : 'no';
        }
        if (consentRetailReferral !== null) {
            consentRetailReferralVal = (consentRetailReferral === null || consentRetailReferral === void 0 ? void 0 : consentRetailReferral.checked) ? 'yes' : 'no';
        }
    }
    let data = {};
    data = {
        dlv_event_category: 'form',
        dlv_form_id: form.dataset.formId,
        dlv_form_name: form.dataset.formName,
        dlv_form_type: form.dataset.formType,
    };
    if (lang === 'en-us') {
        if (consentDataProcessingVal != null)
            data.dlv_form_consent_dataprocess = consentDataProcessingVal;
        if (consentRetailReferralVal != null)
            data.dlv_form_consent_retailreferral = consentRetailReferralVal;
        if (consentMarketingVal != null)
            data.dlv_form_consent_marketing = consentMarketingVal;
    }
    else if (lang === 'en-gb') {
        if (consentDataProcessingVal != null)
            data.dlv_form_consent_dataprocess = consentDataProcessingVal;
        if (consentMarketingVal != null)
            data.dlv_form_consent_marketing = consentMarketingVal;
    }
    return data;
}
const trackLinkClick = (e) => {
    if (!e.target)
        return;
    if (!isLink(e.target, [MainCategoriesItem]))
        return;
    // track click target within shadow dom
    const path = e.composedPath();
    const targetElement = path[0];
    if (targetElement.tagName === 'DIV')
        return;
    const url = getLinkURL(targetElement) || getLinkURL(e.target);
    const isOutbound = !isSameOrigin(url);
    // 'linkClickOutbound' event is used for all link clicks including internal
    metricsTrack('cevt_link_click', {
        dlv_event_category: 'link',
        dlv_event_action: `outbound ${isOutbound}`,
        dlv_link_outbound: isOutbound,
        dlv_link_hostname: new URL(url).hostname,
        dlv_link_element: targetElement,
        dlv_link_classes: targetElement.getAttribute('class'),
        dlv_link_text: targetElement.textContent,
        dlv_link_url: url,
    });
};
document.addEventListener('click', trackLinkClick);

export { getFormAttributes, trackLinkClick };
